import { Component, Input, ViewEncapsulation } from '@angular/core'
import { CardAction, CardComponent, CardLinkAction } from '@spartacus/storefront'

export interface Card {
  header?: string
  title?: string
  textBold?: string
  text?: string[]
  paragraphs?: { title?: string; text?: string[] }[]
  img?: string
  actions?: CardAction[] | CardLinkAction[]
  deleteMsg?: string
  loading?: boolean
  positionToShowSpinner?: number
}

@Component({
    selector: 'eb-card',
    templateUrl: './eb-card.component.html',
    styleUrls: ['./eb-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EbCardComponent extends CardComponent {
  @Input() ghost = false
}
